import axios from "redux/actions/instance";

const requestUri = "/v2/inquiries/request/";

export const patchRequestAPI = (id: number, payload: any) =>
  axios.patch(`${requestUri}${id}/`, payload);


